import Activity from "@via/pages/activity/activity.tsx";

const OrganizationActivity = () => {
  return (
    <>
      <Activity hideContentWrapper={true} />
    </>
  );
};

export default OrganizationActivity;
